var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "carousel-wrapper" },
    [
      _vm.isMultiSlide
        ? _c(
            "carousel",
            { staticClass: "carousel", attrs: { "per-page": 1 } },
            _vm._l(_vm.slides, function (slide) {
              return _c("slide", { key: slide.id }, [
                _c(
                  "div",
                  {
                    class: ["slide-item", slide.cssClass],
                    style: { backgroundImage: `url(${slide.image.src})` },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: [
                          "slide-content",
                          { "no-text": _vm.authType === "login" },
                        ],
                      },
                      [
                        _c("div", { staticClass: "slide-txt" }, [
                          slide.content.step
                            ? _c("p", { staticClass: "slide-step" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(slide.content.step)) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _c("p", { staticClass: "slide-title" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t(slide.content.title)) +
                                "\n              "
                            ),
                            slide.content.subtitle ? _c("br") : _vm._e(),
                            slide.content.subtitle
                              ? _c("strong", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t(slide.content.subtitle)) +
                                      "\n              "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          slide.content.text0
                            ? _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(slide.content.text0)) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          slide.content.text1
                            ? _c("p", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.$t(slide.content.text1))),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            }),
            1
          )
        : _c(
            "carousel",
            { staticClass: "carousel", attrs: { "per-page": 1 } },
            _vm._l(_vm.slides, function (slide) {
              return _c("slide", { key: slide.id }, [
                _c(
                  "div",
                  {
                    class: ["slide-item", slide.cssClass],
                    style: { backgroundImage: `url(${slide.image.src})` },
                  },
                  [
                    _c(
                      "div",
                      {
                        class: [
                          "slide-content",
                          { "no-text": _vm.authType === "login" },
                        ],
                      },
                      [
                        _c("div", { staticClass: "slide-txt" }, [
                          slide.content.step
                            ? _c("p", { staticClass: "slide-step" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(slide.content.step)) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _c("p", { staticClass: "slide-title" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t(slide.content.title)) +
                                "\n              "
                            ),
                            slide.content.subtitle ? _c("br") : _vm._e(),
                            slide.content.subtitle
                              ? _c("strong", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t(slide.content.subtitle)) +
                                      "\n              "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          slide.content.text0
                            ? _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(slide.content.text0)) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          slide.content.text1
                            ? _c("p", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.$t(slide.content.text1))),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            }),
            1
          ),
      _c("div", { staticClass: "language-wrapper" }, [
        _c(
          "div",
          {
            ref: "dropdown",
            staticClass: "custom-dropdown",
            class: { open: _vm.dropdownOpen },
          },
          [
            _c(
              "button",
              {
                staticClass: "dropdown-trigger",
                attrs: {
                  type: "button",
                  "aria-expanded": _vm.dropdownOpen,
                  "aria-haspopup": "true",
                  "aria-label": _vm.$t("auth.language.select"),
                },
                on: { click: _vm.toggleDropdown },
              },
              [
                _c("p", { staticClass: "locale" }, [
                  _vm._v(_vm._s(this.$i18n.locale.toUpperCase())),
                ]),
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("keyboard_arrow_down"),
                ]),
              ]
            ),
            _vm.dropdownOpen
              ? _c(
                  "ul",
                  {
                    staticClass: "dropdown-menu select-lang",
                    attrs: { role: "menu" },
                  },
                  _vm._l(_vm.locales, function (lang) {
                    return _c(
                      "li",
                      {
                        key: lang,
                        class: [lang, { active: lang === _vm.$i18n.locale }],
                        attrs: {
                          role: "menuitem",
                          "aria-selected": lang === _vm.$i18n.locale,
                          tabindex: "0",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.changeLocale(lang)
                          },
                          keydown: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.changeLocale(lang)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              )
                                return null
                              $event.preventDefault()
                              return _vm.changeLocale(lang)
                            },
                          ],
                        },
                      },
                      [_c("p", [_vm._v(_vm._s(lang.toUpperCase()))])]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }